import React from "react";
import PropTypes from "prop-types";
import { CardTitle, Icon } from "@components";

export class FormHeader extends React.Component {
  render() {
    return (
      <CardTitle className="text-primary pb-3">
        {this.props.title}
        {this.props.mandatoryTitle && (
          <small className="float-right text-muted">
            <Icon icon="asterisk" size="sm" className="mr-2 text-warning" />
            Denotes mandatory
          </small>
        )}
      </CardTitle>
    );
  }
}

FormHeader.propTypes = {
  title: PropTypes.string.isRequired,
  mandatoryTitle: PropTypes.bool,
};

FormHeader.defaultProps = {
  mandatoryTitle: false,
};

export default FormHeader;
